import React from 'react';

import { useTranslation } from '@lyearn/i18n';
import { Button, Stack, Typography } from '@lyearn/ui';
import { Link } from '@/components/Link';
import { defaultRoute } from '@/pages/corporate/routes/admin';
import {
  useAdminRoute,
  useRoleBasedNavigation,
} from '@/pages/corporate/routes/hooks/useAdminRoutes';

import { ErrorAccessProps } from './types';

function ErrorAccess(props: ErrorAccessProps) {
  const { resource } = props;
  const { t } = useTranslation();
  const isAdminRoute = useAdminRoute();
  const rootRoute = useRoleBasedNavigation(defaultRoute());

  return (
    <Stack
      alignItems="center"
      className="h-full flex-1 xs:p-24"
      direction="col"
      justifyContent="center">
      <Typography className="xs:text-center" variant="heading-xl">
        {t('Common:Error.DeniedAccess', { resource })}
      </Typography>
      <Typography
        className="mt-16 xs:text-center"
        color="text-text-secondary"
        variant="body-long-01">
        {t('Common:Error.DeniedAccessDescription')}
      </Typography>
      <Link to={rootRoute}>
        <Button className="mt-40">
          {isAdminRoute ? t('Common:Actions.GoBack') : t('Common:Actions.BackToHome')}
        </Button>
      </Link>
    </Stack>
  );
}

export default ErrorAccess;
